var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import useTaroHoverableEvents from '../_util/hooks/useTaroHoverableEvents';
const View = (_a, ref) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    const props = useTaroHoverableEvents(rest, 'none');
    return (_jsx("div", Object.assign({ ref: ref }, props, { children: children })));
};
export default forwardRef(View);
